import { Truck, Store, CreditCard, CalendarClock, type LucideIcon } from "lucide-react"
import { Container } from "@/components/layout/Container"

interface TrustItem {
	icon: LucideIcon
	title: string
	text: string
}

const TRUST_ITEMS: TrustItem[] = [
	{ icon: Truck, title: "Envío a todo México", text: "Recíbelo de 1 a 3 días hábiles." },
	{ icon: Store, title: "Paga en efectivo", text: "Aceptamos pagos en tiendas OXXO." },
	{ icon: CreditCard, title: "Todas las tarjetas", text: "Crédito y débito, pago seguro." },
	{ icon: CalendarClock, title: "Meses sin intereses", text: "A 3 y 6 meses en tarjetas participantes." }
]

/** Sección 5: franja de confianza de compra (envío, OXXO, tarjetas, MSI). */
export function TrustStrip(): React.JSX.Element {
	return (
		<section className="border-y bg-background">
			<Container className="py-12 md:py-16">
				<ul className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
					{TRUST_ITEMS.map(({ icon: Icon, title, text }) => (
						<li
							key={title}
							className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-start sm:text-left"
						>
							<span className="inline-flex size-12 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
								<Icon className="size-6" />
							</span>
							<div>
								<h3 className="font-semibold">{title}</h3>
								<p className="mt-1 text-sm text-muted-foreground">{text}</p>
							</div>
						</li>
					))}
				</ul>
			</Container>
		</section>
	)
}
